import { z } from 'zod';
import { objectIdSchema } from './objectId';
import { WithIdSchema, WithTimestampSchema } from './utils';
import { PropertySchema } from './property';
import { BrandStaffDepartmentSchema } from './brandStaffDepartment';
import { PropertyBerthingSchema } from './propertyBerthing';

export const NewStaffTemplateSchema = z.object({
  title: z.string(),
  department: objectIdSchema,
  berthing: objectIdSchema,
  quantity: z.number(),
  property: objectIdSchema,
});

export const BareStaffTemplateSchema = NewStaffTemplateSchema.and(WithIdSchema).and(
  WithTimestampSchema.partial()
);

export const StaffTemplateSchema = z.object({
  _id: objectIdSchema,
  title: z.string(),
  department: BrandStaffDepartmentSchema,
  berthing: PropertyBerthingSchema,
  quantity: z.number(),
  property: PropertySchema,
});

export type BareStaffTemplate = z.infer<typeof BareStaffTemplateSchema>;
